/* global debounce */
if (!customElements.get('box-finder')) {
    class BoxFinder extends HTMLElement {
      constructor() {
        super();
        this.field1 = this.querySelector('.length-input')
        this.field2 = this.querySelector('.width-input')
        this.field3 = this.querySelector('.height-input')
        this.btn = this.querySelector('.js-box-search');



        this.btn.addEventListener('click',()=>{
            if(this.field1.value == '' &&  this.field2.value == '' &&  this.field3.value == '')
            {
                console.log('please input')
                //this.btn.disabled  = true ;
            }
            else
            {
                let url = `/search?type=article%2Cpage%2Cproduct&options%5Bprefix%5D=last&q=`;

                if( this.field1.value != '' )
                {
                  url = url +`${this.field1.value} `;
                }
                if( this.field2.value != '' )
                {
                  url = url + `${this.field2.value} `;
                }

                if( this.field3.value != '' )
                {
                  url = url + `${this.field3.value} `;
                }
              

                if( this.field1.value != '' )
                {
                   url = url +`&filter.p.m.global.float-length=${this.field1.value}`
                }
                if( this.field2.value != '' )
                {
                   url = url +`&filter.p.m.global.float-width=${this.field2.value}`
                }
                if( this.field3.value != '' )
                {
                   url = url +`&filter.p.m.global.float-height=${this.field3.value}`
                }
                this.navigation(url);
            }
        })

      
      }
  
      navigation(url) {
         console.log('url', url )
         window.location.href = url;
      }
    }
    customElements.define('box-finder', BoxFinder);
}
  